import React from "react";
import { ReactComponent as Edit } from "../../assets/icons/edit.svg";
import { useCustomTranslation } from "@/hooks/useTranslation";
import { hoveredStepNumber } from "./ShowOriginal";
import { useGlobalStore } from "@/store";
import { FETreatmentGeneration } from "./Mesh";
import { reApplySavedAttachments } from "./teethControls/addRemoveAttachment";
import { customTeethGizmoControls } from "./Camera";

export const ShowContModification = ({
  showOriginalRemovedHover,
  setToggle,
  showContModification,
}) => {
  const { setStepperControls } = useGlobalStore(state => ({
    setStepperControls: state.setStepperControls,
  }));
  const { content } = useCustomTranslation();

  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };

  const handleClick = () => {
    setToggle("showContModification", !showContModification);
    FETreatmentGeneration.moveToStep(hoveredStepNumber);
    reApplySavedAttachments(FETreatmentGeneration.getCurrentStep());
    showOriginalRemovedHover(true);
    setStepperControls("currentStep", hoveredStepNumber);
    setStepperControls("storedStep", hoveredStepNumber);
    customTeethGizmoControls.setIsEnabled(showContModification);
  };

  return (
    <button
      onClick={handleClick}
      className="mb-2 grid w-[258px] grid-cols-[1fr,auto] rounded border-2 border-solid border-[#009ACE] bg-white px-4 py-4 text-[#009ACE]"
    >
      <div className="text-start text-base font-medium">
        {getContent("actions", "continue_modifications")}{" "}
      </div>
      <Edit />
    </button>
  );
};
